import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import { automationQueries } from '@/features/air/automation-settings/queries'
import { policyQueries } from '@/features/air/policy-management/queries'
import { RouteErrorComponent } from '@/features/app-shell/route-error-component'

import { getCurrentTenant } from '@/shared/auth/store'
import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

import { ErrorBoundary } from '@/components/common/error-boundary'

const AutomationSettingsTable = lazy(
	() => import('@/features/air/automation-settings/components/table'),
)

const searchSchema = z.object({
	q: z.string().optional(),
})

export const Route = createFileRoute(
	'/_dashboard/air/_layout/automation-settings',
)({
	validateSearch: zodValidator(searchSchema),

	loader: ({ context: { queryClient } }) => {
		const tenant_id = getCurrentTenant()

		if (tenant_id) {
			queryClient.prefetchQuery(policyQueries.policies_list(tenant_id))
			queryClient.ensureQueryData({
				...automationQueries.automations_list(tenant_id),
				revalidateIfStale: true,
			})
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Automation Settings | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RoutePendingComponent,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<ErrorBoundary feature="air-automation" section="list">
			<Suspense fallback={<TableFullSkeleton withLastUpdated rows={5} />}>
				<AutomationSettingsTable />
			</Suspense>
		</ErrorBoundary>
	)
}

function RoutePendingComponent() {
	return (
		<div className="flex flex-col gap-4">
			<TableFullSkeleton withLastUpdated rows={5} />
		</div>
	)
}
